// src/firebase.js
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBjUAhHCH3DJfK3Vo7UH3B2JmkW_mm28_0",
  authDomain: "omova-e8c37.firebaseapp.com",
  pprojectId: "omova-e8c37",
  storageBucket: "omova-e8c37.appspot.com",
  messagingSenderId: "985754876345",
  appId: "1:985754876345:web:1e1074d2b2d1a585259e68",
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
